import React from 'react';
import PublicPageLayout from '../../components/PublicPageLayout';
import {io} from 'socket.io-client';
import {LoadGraphic} from '../../components/Common';
import {TextButton} from '../../components/Input';
import moment from 'moment';
import u from '../../utilities/Utilities';
import store from 'store';
import "../../styles/dashboard-generic.scss";
import "../../styles/dashboards/psa-dashboards.scss";
import {Chart, Line, Bar} from 'react-chartjs-2';

export default class PSAOperationalStatistics extends React.Component{

    socketType="Operational Statistics";

    pollInterval=5000;

    dormID = this.props.match.params.dormID;

    state={
        content:{
            charts:[],
        },
        instantiated:false,
        showValues:false,
        options:{
            responsive: true,
            maintainAspectRatio:false,
            showLines:true,
            spanGaps:false,
            plugins:{
              legend:{
                display:false,
              },
              datalabels:{
                  display:false,
                  align:"end",
                  anchor:"end",
                  offset:2,
              },
            },
        }
    };

    componentDidMount=()=>{
        this.interval=setInterval(()=>{
            this.setState({updateState:!this.state.updateState});
        },1000);

        //this.getSocketInfo();

        this.getContent();

        this.contentInterval=setInterval(()=>{
            this.getContent();
        },this.pollInterval);
    }

    componentWillUnmount=()=>{
        clearInterval(this.interval);
        clearInterval(this.contentInterval);
    }

    getContent=()=>{
        this.setState({error:""});
        u.post({
            url:"/api/get-dashboard-content",
            data:{
                dormID:this.dormID,
                type:this.socketType,
            },
            success:(content)=>{
                let modContent = this.modContent(content);
                this.setState({content:modContent,instantiated:true});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getSocketInfo=()=>{
        this.setState({loading:true,loadText:"Getting server info..."});
        u.post({
            url:"/api/get-socket-info",
            data:{},
            success:({socketIP,socketToken})=>{
                this.token=socketToken;
                this.socketIP=socketIP;
                this.setupSocket();
            },
            error:(error)=>{
                this.setState({loadText:error});
            }
        })
    }

    setupSocket=()=>{
        this.socket = io(this.socketIP,{
            reconnectionDelayMax: 5000,
            withCredentials: true,
            extraHeaders:{
                "csrf-token":store.get("csrfToken"),
                "socket-token":this.token,
            },
            transports:["websocket"],
        });

        this.socket.on('connect',()=>{
            this.setState({sessionID:this.socket.id,connected:true});
            //Initial Emit
            this.socket.emit("get-base-state",
            {
                socketID:this.socket.id,
                socketType:this.socketType,
            });
        });

        this.socket.on("disconnect",()=>{
            this.setState({connected:false});
        });

        this.socket.on("set-base-state",(content)=>{
            let modContent = this.modContent(content);
            this.setState({content:modContent});
        });
    }

    modContent=(content)=>{
        content.charts = content.charts.map(
            (chart)=>{
                if(chart.type=="line"){
                    chart.datasets = chart.datasets.map((item)=>{
                        if(item.borderColor=="gradient"){
                            item.borderColor=this.drawGradient;
                        }
                        return item;
                    });
                }
                return chart;
            }
        )
        return content;
    }

    psaColors=[
      u.hexToRgb("#229dce"),
      u.hexToRgb("#37a7b6"),
      u.hexToRgb("#63c08a"),
      u.hexToRgb("#8ed75e"),
      u.hexToRgb("#a5e348"),
      u.hexToRgb("#cac9d0"),
    ];

    getGradient=(ctx, chartArea)=>{
        let width, height, gradient;
        const chartWidth = chartArea.right - chartArea.left;
        const chartHeight = chartArea.bottom - chartArea.top;
        if (!gradient || width !== chartWidth || height !== chartHeight) {
          // Create the gradient because this is either the first render
          // or the size of the chart has changed
          width = chartWidth;
          height = chartHeight;
          gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0);
          gradient.addColorStop(0, this.psaColors[0].hex);
          gradient.addColorStop(0.5, this.psaColors[3].hex);
          gradient.addColorStop(1, this.psaColors[5].hex);
      }
      return gradient;
    }

    drawGradient=(context)=>{
         const chart = context.chart;
         const {ctx, chartArea} = chart;
         if (!chartArea) {
           // This case happens on initial chart load
           return;
         }
         return this.getGradient(ctx, chartArea);
    }

    onToggleValues=()=>{
        let newValue=!this.state.showValues;
        let options=this.state.options;
        options.plugins.datalabels.display=newValue;
        this.setState({showValues:newValue,options:options});
    }

    render=()=>{
        const content=this.state.content;
        const options=this.state.options;

        return(
            <PublicPageLayout url="/psa-operational-status" title={this.socketType}>
                <LoadGraphic active={!this.state.instantiated} text="Preparing"/>

                <div className="psa-dashboard-header-container" style={{height:"0"}}>
                    <div className="psa-dashboard-header">
                        <div className="pdh-title"><h2>{this.socketType.toUpperCase()}</h2></div>
                        <div className='pdh-title right'><h2><Clock/></h2></div>
                    </div>
                </div>

                <div className="psa-graphs-container">
                    {
                        content.charts.map(
                            (item,index)=>{
                                const maxY = Math.max(...item.datasets[0].data);
                                if(item.type=="line"){
                                  return(
                                      <div key={index} className="psa-graph-container">
                                          <h2 className="psa-graph-title">{item.label}</h2>
                                          <div className="psa-graph">
                                              <Line options={{
                                                      ...options,
                                                      scales:{
                                                          x:{
                                                              ticks: {
                                                                  autoSkip: true,
                                                                  autoSkipPadding: 20,
                                                              }
                                                          },
                                                          y:{
                                                              display:true,
                                                              beginAtZero:true,
                                                              steps:5,
                                                              suggestedMax:maxY + 10,

                                                          },
                                                      },
                                                      layout:{
                                                          padding:{
                                                              right:10,
                                                              top:10,
                                                          }
                                                      },
                                                    }}
                                                    data={item}
                                                    redraw={false}
                                                    />
                                          </div>
                                      </div>
                                  )
                                }
                                return (
                                    <div key={index} className="psa-graph-container">
                                        <h2 className="psa-graph-title">{item.label}</h2>
                                        <div className="psa-graph">
                                            <Bar options={{
                                                  ...options,
                                                  scales:{
                                                      y:{
                                                          display:true,
                                                          beginAtZero:true,
                                                          steps:5,
                                                          suggestedMax:maxY+10,
                                                      },
                                                  },
                                                  layout:{
                                                      padding:{
                                                          top:10,
                                                          right:10,
                                                      }
                                                  },
                                                 }}
                                                 data={item}
                                                 redraw={false}
                                                 />
                                        </div>
                                    </div>
                                )
                            }
                        )
                    }
                </div>

                <div style={{fontSize:"0.75em",height:"0",marginTop:"-9px",textAlign:"center"}}>
                    <TextButton onClick={this.onToggleValues}>
                        {(this.state.showValues) ? "HIDE" : "DISPLAY"} VALUES
                    </TextButton>
                </div>
            </PublicPageLayout>
        )
    }
}

export class Clock extends React.Component{

    state={
        reload:false
    }

    componentDidMount=()=>{
        this.interval = setInterval(()=>{
            this.setState({reload:!this.state.reload});
        },1000);
    }

    componentWillUnmount=()=>{
        if(this.interval){
            clearInterval(this.interval);
        }
    }

    render=()=>{
        return (
            <span>{moment().format("DD MMM YY h:mma")}</span>
        )
    }
}
